module.exports = __webpack_public_path__ + "static/media/Vishwesh Pujari.70dd1954.jpg";